export default {
  name: 'ActionAdder',
  props: ['all_actions'],
  emits: ['success'],
  computed: {
    selectedProvider: function selectedProvider() {
      var selectedProviderKey = this.action.action_provider;
      if (!selectedProviderKey) {
        return false;
      }
      return this.all_actions[selectedProviderKey];
    }
  },
  data: function data() {
    return {
      action: {
        title: '',
        action_name: '',
        action_provider: '',
        status: 'draft',
        settings: {}
      }
    };
  },
  methods: {
    changeActionProvider: function changeActionProvider(provider) {
      this.action.action_provider = provider;
    },
    actionSuccess: function actionSuccess() {
      this.action.is_open = true;
      this.$emit('success', this.action);
      this.action = {
        title: '',
        action_name: '',
        action_provider: '',
        status: 'draft',
        settings: {}
      };
    }
  },
  mounted: function mounted() {
    //  this.changeActionProvider('fluentcrm');
  }
};